import { Routes, Route, Navigate } from 'react-router-dom'
import Layout from '../../components/Layout'
import ClientHome from './ClientHome'
import ClientProfile from './ClientProfile'
import ClientScheduleSession from './ClientScheduleSession'
import ClientInterviews from './ClientInterviews'
import ClientSession from './ClientSession'
import ClientFeedback from './ClientFeedback'
import ClientPaymentSuccess from './ClientPaymentSuccess'

export default function ClientDashboard() {
  return (
    <Layout role="client">
      <Routes>
        <Route index element={<Navigate to="home" replace />} />
        <Route path="home" element={<ClientHome />} />
        <Route path="schedule" element={<ClientScheduleSession />} />
        <Route path="interviews" element={<ClientInterviews />} />
        <Route path="interviews/:source/:sourceId" element={<ClientSession />} />
        <Route path="interviews/:id" element={<ClientSession />} />
        <Route path="feedback" element={<ClientFeedback />} />
        <Route path="profile" element={<ClientProfile />} />
        <Route path="payment-success" element={<ClientPaymentSuccess />} />
      </Routes>
    </Layout>
  )
}
